import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  peopleTabbedNav: {
    //
  },
  totalPeople:{
    color:  theme.text.themeColor,
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    backgroundColor: theme?.tabs?.numberBadge?.backgroundColor || colors.primary50Blue,
    marginBottom: 0,
    marginLeft: "6px",
    padding: "2px 8px 1px 8px",
    borderRadius: "16px"
  },
  tabs: {
    borderColor: theme.tabs.borderColor,
    "& li": {
      "& button": {
        marginRight:"16px",
        "&.nav-link": {
          display: "flex",
          alignItems: "center",
          border: "none",
          color: theme.tabs.color,
          borderColor: theme.tabs.borderColor,
          fontWeight:"600",
          padding: "0px 4px 9px",
          "&.active": {
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
          "&:hover":{
            border: "none",
            color: theme.tabs.activeColor,
            borderBottom: theme.tabs.borderBottom,
          },
          "&:focus-visible":{
            boxShadow:"none",
            border: `1px solid ${colors.black}`,
          },
        }
      }
    }
  }
}));

export default styles;

export const tabsSelectOpen = {
  dropdownIndicator: (base, { selectProps }) => ({
    ...base,
    padding:"12px",
    transition: selectProps.menuIsOpen ? 'all .2s ease' : "none",
    transform: selectProps.menuIsOpen ? 'rotate(180deg)' : "none",
  }),
}
